module.exports = __webpack_public_path__ + "img/ability-lab.9d16bf9d.svg";